// Widget.js - Reusable widget wrapper component
import React from 'react';

const Widget = ({
  title,
  children,
  className = '',
  loading = false,
  error = null,
  headerAction = null
}) => {
  return (
    <div className={`bg-gray-800 rounded-lg p-4 ${className}`}>
      {(title || headerAction) && (
        <div className="flex items-center justify-between mb-4">
          {title && <h3 className="text-lg font-semibold text-white">{title}</h3>}
          {headerAction}
        </div>
      )}

      {loading ? (
        <div className="flex items-center justify-center h-32">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-32 text-red-400">
          {error}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default Widget;
